<app-input
  [inputType]="'editor'"
  [formControl]="commentControl"
  [placeholder]="'add_comment' | translate"
/>
<div class="mt-3 flex justify-end">
  <app-button
    [disabled]="!commentControl.value?.trim() || submittingComment"
    (onChangeClick)="submitComment()"
  >
    {{ 'send' | translate }}
  </app-button>
</div>
